import {
  UpdateDTO,
  useUpdateMutationFactory,
  UseUpdateMutationProps,
} from '@/lib/react-query/update';
import { CalendarNote } from '@/types';
import { update } from '@/utils/api';
import { featureKeys, featurePath, NoteSearchParams } from '.';

export type UpdateNoteDTO = UpdateDTO<CalendarNote, NoteSearchParams>;

const updateNote = ({ data, id, params = {} }: UpdateNoteDTO) =>
  update<CalendarNote>(`${featurePath}/${id}`, data, params);

export const useUpdateNote = (options?: UseUpdateMutationProps<CalendarNote>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: updateNote,
    ...options,
  });
};
